import React, { useState, useEffect, useRef } from "react";
import { Button } from "./ui";
import MapView from "./MapView";
import { useTheme } from "../context/ThemeContext";
import { useGeo } from "../context/GeoContext";

const Modal2 = ({ partido, onFeatureDataChange }) => {
    const { clearFeatures } = useGeo();
    const { isDarkMode } = useTheme();
    const [isOpen, setIsOpen] = useState(false);
    const [geoJSONData, setGeoJSONData] = useState(null);
    console.log("GeoJSONData en Modal2", geoJSONData)
    const [mounted, setMounted] = useState(true);
    const [localFeatureData, setLocalFeatureData] = useState([]);
    const [savedFeatures, setSavedFeatures] = useState([]);
    const mapViewRef = useRef(null);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const handleGeoJSONReceived = (geojsonData) => {
        console.log("Datos recibidos en handleGeoJSONReceived:", geojsonData);
        
        // Verificar si los datos son un FeatureCollection de GeoJSON
        if (geojsonData && 
            typeof geojsonData === 'object' && 
            geojsonData.type === 'FeatureCollection' && 
            Array.isArray(geojsonData.features)) {
            
            console.log("FeatureCollection válido recibido con", geojsonData.features.length, "features");
            setGeoJSONData(geojsonData);
            setLocalFeatureData(geojsonData);
            
            // Notificar al componente padre
            if (onFeatureDataChange) {
                onFeatureDataChange(geojsonData);
            }
        } else {
            console.error("Datos recibidos no son un FeatureCollection de GeoJSON válido:", geojsonData);
        }
    };

    const handleFeatureDataChange = (data) => {
        setLocalFeatureData(data);
        if (onFeatureDataChange) {
            onFeatureDataChange(data);
        }
    };

    const handleCancel = () => {
        // Limpiar las features del GeoContext
        clearFeatures();
        // Limpiar los datos del mapa y notificar al componente padre
        if (onFeatureDataChange) {
            onFeatureDataChange([]);
        }
        
        // Limpiar todos los estados locales
        setLocalFeatureData([]);
        setSavedFeatures([]);
        
        closeModal();
    };

    const handleSaveAndClose = () => {
        // Guardar los datos actuales (si existen) y cerrar
        if (onFeatureDataChange) {
            // Si hay datos locales, los guardamos, si no, guardamos un array vacío
            const featuresToSave = localFeatureData || [];
            setSavedFeatures(featuresToSave); // Guardar las features localmente
            onFeatureDataChange(featuresToSave);
        }
        closeModal();
    };

    if (!mounted) return null;

    return (
        <div>
            <Button
                onClick={openModal}
                disabled={!partido || partido === 0 || partido === '0'}
                className={`px-4 py-2 rounded text-white ${
                    !partido || partido === 0 || partido === '0'
                        ? 'bg-blue-500 opacity-50 cursor-not-allowed'
                        : 'bg-blue-500 hover:bg-blue-600'
                }`}
            >
                Mapeo de las áreas de intervención
            </Button>

            {isOpen && (
                <div 
                    className={`fixed inset-0 z-50 flex items-center justify-center ${
                        isDarkMode ? 'bg-black/70' : 'bg-black/50'
                    } transition-colors duration-200`}
                    onClick={closeModal}
                >
                    <div
                        className={`w-[80vw] h-[80vh] rounded-lg shadow-xl flex flex-col overflow-hidden transition-colors duration-200 ${
                            isDarkMode ? 'bg-gray-800' : 'bg-white'
                        }`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={`p-6 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                            <h2 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                Agregar Proyectos
                            </h2>
                        </div>

                        <div className={`flex-grow overflow-auto ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                            {mounted && (
                                <MapView 
                                    ref={mapViewRef}
                                    key={`map-${mounted}`}
                                    onClose={handleGeoJSONReceived} 
                                    partido={partido}
                                    onFeatureDataChange={handleFeatureDataChange}
                                    initialFeatures={savedFeatures}
                                />
                            )}
                        </div>

                        <div className={`p-4 flex justify-between items-center border-t ${isDarkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-white'}`}>
                            <Button
                                onClick={handleCancel}
                                className="px-4 py-2 text-white bg-gray-500 rounded hover:bg-gray-600 transition-colors duration-200"
                            >
                                Cancelar
                            </Button>
                            <div className="flex space-x-2">
                                <Button
                                    onClick={handleSaveAndClose}
                                    className="px-4 py-2 text-white bg-green-500 rounded hover:bg-green-600 transition-colors duration-200"
                                >
                                    Guardar y Salir
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default Modal2;
